import { h, Component } from 'preact';

import { sortObjectByOrder, joinClasses, accessNested } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll';
import { getCopy } from 'utils/copy';

import Store from 'store/store';
import Time from 'components/shared/time/time';
import Subscribe from 'components/shared/subscribe/subscribe';
import s from 'components/shared/footer/footer.sss';

export default class Footer extends Component {
	constructor(props) {
		super(props);
		this.onContactClick = this.onContactClick.bind(this);
	}

	onContactClick() {
		const activePage = accessNested(this.props, 'store.activePage');
		if (activePage === 'contact') {
			smoothScrollTo('root', 0, 500);
		} else {
			Store.emit('SET_ACTIVE_PAGE', 'contact');
		}
	}

	render(props) {
		const { data, socials = [], active, powSubscribeActive } = props;
		const {
			links,
			copyright,
			title,
			contactCta,
			careerCta,
			contactCopy
		} = data;

		const sortedLinks = sortObjectByOrder(links);
		const isDesktop = props.client.isDesktopSize;

		return (
			<div class={joinClasses(s.footer, active && s.active)}>
				{powSubscribeActive && (
					<Subscribe
						toggleForm={props.toggleSubscribeForm}
						formOpen={props.subscribeFormOpen}
					/>
				)}
				<div class={s.content}>
					<div class={s.top}>
						<div class={s.headings}>
							<h3 class={joinClasses(s.title, isDesktop ? 'heading2' : 'heading3')}>{title}</h3>
							<div class={s.ctas}>
								<button class={joinClasses(s.cta, isDesktop ? 'large' : 'medium')} onClick={this.onContactClick}>{contactCta}</button>
								<div class={s.divider} />
								<a href={careerCta.href} target='_blank' class={joinClasses(s.cta, isDesktop ? 'large' : 'medium')}>{careerCta.label}</a>
							</div>
						</div>
						<Time active={active} contactCopy={contactCopy} isDesktop={isDesktop} />
					</div>
					<div class={s.flexWrapper}>
						<div class={s.logo} onClick={() => smoothScrollTo('root', 0, 500)} />
						<div class={s.socials}>
							{socials.map(({ id, href }) => <a class={joinClasses(s.social, s[id])} href={href} target="_blank" />)}
						</div>
					</div>
					<div class={s.container}>
						<div class={s.links}>
							{sortedLinks.map(({ id, $copy, href, pageId }) => {
								let onClick;
								let target = '_blank';
								if (pageId) {
									href = accessNested(this.props, ['store', 'appData', 'pages', pageId, 'path']) || '#';
									onClick = e => {
										e.preventDefault();
										Store.emit('SET_ACTIVE_PAGE', pageId);
									};
									target = undefined;
								}
								return (
									<a class={joinClasses(s.link, s[id], 'small')} target={target} href={href} onClick={onClick}>
										{getCopy($copy)}
									</a>
								);
							})}
							<div class={joinClasses(s.copyright, s.link, 'small')}>{copyright.powster.$copy}</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
